import React from 'react';
import { Modal, Typography, Icon } from '@ann/web-components';
import { ModalBodyContent, WarningIconContainer, MessageText } from './DeactivateReactivateUserModal.styled';

const DeactivateReactivateUserModal = ({
  isOpen,
  onClose,
  onConfirm,
  selectedUsersCount = 0,
  selectedUser = null, // { name, email } cuando solo hay un usuario seleccionado
  isLoading = false,
  action = 'deactivate' // 'deactivate' or 'reactivate'
}) => {
  const isDeactivate = action === 'deactivate';
  const actionLabel = isDeactivate ? 'Deactivate' : 'Reactivate';
  const isSingleUser = selectedUsersCount === 1 && selectedUser;
  
  const title = isSingleUser 
    ? `${actionLabel} user from workspace`
    : `${actionLabel} user${selectedUsersCount !== 1 ? 's' : ''} from workspace`;
  
  const message = isDeactivate
    ? isSingleUser
      ? (
          <>
            Are you sure you want to deactivate {selectedUser.name} · {selectedUser.email} from this workspace?
            <br />
            Will lose access immediately. Their activity history will remain saved.
          </>
        )
      : (
          <>
            You're about to deactivate {selectedUsersCount} selected user{selectedUsersCount !== 1 ? 's' : ''} from this workspace.
            <br />
            They will lose access immediately. Their activity history will remain saved.
          </>
        )
    : isSingleUser
      ? (
          <>
            Are you sure you want to reactivate {selectedUser.name} · {selectedUser.email} in this workspace?
            <br />
            They will regain access immediately.
          </>
        )
      : (
          <>
            You're about to reactivate {selectedUsersCount} selected user{selectedUsersCount !== 1 ? 's' : ''} in this workspace.
            <br />
            They will regain access immediately.
          </>
        );

  const handleClose = () => {
    if (!isLoading) {
      onClose();
    }
  };

  const handleConfirm = () => {
    if (!isLoading && onConfirm) {
      onConfirm();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} width="900px" size="medium">
      <Modal.Header>
        <Modal.Header.Title/>      
      </Modal.Header>
      <Modal.Body>
        <ModalBodyContent>
          <WarningIconContainer>
            <Icon color="warning" name="warning" size="large"/>
          </WarningIconContainer>
          <MessageText>
            <Typography category="title" size="small" weight="bold">
              {title}
            </Typography>
            <Typography category="body" size="small" weight="regular" color="body">
              {message}
            </Typography>
          </MessageText>
        </ModalBodyContent>
      </Modal.Body>
      <Modal.Actions align="center">
        <Modal.Button
          label="Cancel"
          onClick={handleClose}
          type="secondary"
          disabled={isLoading}
        />
        <Modal.Button
          label={`${actionLabel} user${selectedUsersCount !== 1 ? 's' : ''}`}
          onClick={handleConfirm}
          type={isDeactivate ? "error" : "primary"}
          disabled={false}
          isLoading={isLoading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default DeactivateReactivateUserModal;

